<script setup>
/* global axios */
// Usamos el `axios` GLOBAL (window.axios) que configura Chatwoot al boot con los
// headers de auth (devise-token-auth) y el baseURL. El módulo 'axios' importado
// es crudo y NO lleva esos headers → daba 401. Igual que app/javascript/dashboard/api/ApiClient.js.
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useSidebarResize } from 'dashboard/components-next/sidebar/provider';

// El src del iframe se obtiene por SSO: pedimos al backend un token minteado y
// cargamos <dashboard>/sso?token=... (si cargaramos la URL directa, el dashboard
// nos mandaria a su propio login).
const src = ref(null);
const route = useRoute();

const { snapToCollapsed, snapToExpanded, sidebarWidth } = useSidebarResize();

let previousWidth = 240;

onMounted(async () => {
  previousWidth = sidebarWidth.value;
  snapToCollapsed();
  const { data } = await axios.get(
    `/api/v1/accounts/${route.params.accountId}/analytics_sso`
  );
  src.value = data.url;
});

onBeforeUnmount(() => {
  if (previousWidth > 56) snapToExpanded();
});
</script>

<template>
  <div class="flex flex-col w-full h-full">
    <iframe
      v-if="src"
      :src="src"
      class="w-full h-full border-0"
      allow="fullscreen"
      title="Analytics Dashboard"
    />
  </div>
</template>
